'use strict'
import serviceBase from './serviceBase'
const companyBookingApiService = {
    GetAvailableMasters:(data)=>serviceBase.post('/suitesolutions-companybooking/api/GetAvailableMasters',data),
    GetCompanyProfileByClientUId:(data)=>serviceBase.post(`/suitesolutions-companybooking/apis/GetCompanyProfileByClientUId&&clientid=${data.clientid}`),
    GetInvoiceAmount:(data)=>serviceBase.post('/suitesolutions-companybooking/api/GetInvoiceAmount', data),
    CreateStripeOrder:(data)=>serviceBase.post('/suitesolutions-companybooking/api/CreateStripeOrder',data),
}
export default companyBookingApiService